var resolveKeyword = require('../../utils/names.js').keyword;
var compressKeyframes = require('./atrule/keyframes.js');

module.exports = function(node) {
    // compress @keyframe selectors
    if (resolveKeyword(node.name).name === 'keyframes') {
        compressKeyframes(node);
    }
};



//////////////////
// WEBPACK FOOTER
// ./~/csso/lib/compressor/compress/Atrule.js
// module id = 2519
// module chunks = 0